import React from 'react';

export default function Build() {
  return (
    <div id="build">
      <div className="pt-6 pb-24 bg-gray-300 lg:text-center lg:pt-12">
        <div className="container px-10 mx-auto">
          <div className="mb-8 space-y-2 text-center text-gray-800">
            <h2 className="text-5xl">What we build</h2>
            <p className="text-lg text-gray-700">
              These components are things you'll have to create in every
              project.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-5 lg:grid-cols-3 xl:grid-cols-4 md:grid-cols-2">
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-red-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Buttons</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-purple-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Card</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-green-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Footer</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 text-3xl bg-blue-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Header</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-teal-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Buttons</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-gray-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Card</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-purple-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Footer</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 text-3xl bg-red-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Header</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-yellow-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Buttons</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-purple-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Card</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 p-4 text-3xl bg-orange-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Footer</div>
            </div>
            <div className="flex bg-white rounded shadow">
              <div className="flex items-center justify-center w-1/5 text-3xl bg-teal-500 rounded-l">
                😍
              </div>
              <div className="p-6 font-semibold text-gray-600">Header</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
